export enum EmailTypes {
  invitation = 'invitation',
  reminder = 'reminder',
  reminderNoStartCourse = 'reminder_no_start_course',
}
